import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'cookie-consent-accepted';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const [buttonHovered, setButtonHovered] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div style={styles.banner}>
      <p style={styles.text}>
        We use cookies for authentication and analytics.{' '}
        <Link to="/privacy" style={styles.link}>Learn more</Link>
      </p>
      <button
        onClick={handleAccept}
        style={{
          ...styles.button,
          ...(buttonHovered ? styles.buttonHovered : {}),
        }}
        onMouseEnter={() => setButtonHovered(true)}
        onMouseLeave={() => setButtonHovered(false)}
      >
        Accept
      </button>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  banner: {
    position: 'fixed',
    bottom: '1.5rem',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center',
    gap: '1.25rem',
    padding: '1rem 1.5rem',
    background: 'white',
    borderRadius: '14px',
    border: '1px solid rgba(0, 0, 0, 0.08)',
    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.12)',
    zIndex: 9999,
    maxWidth: '560px',
    width: 'calc(100% - 2rem)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Display", "Segoe UI", Roboto, sans-serif',
  },
  text: {
    fontSize: '0.9rem',
    color: '#4a4a5a',
    margin: 0,
    lineHeight: 1.5,
    flex: 1,
  },
  link: {
    color: '#059669',
    textDecoration: 'none',
    fontWeight: 500,
  },
  button: {
    padding: '0.55rem 1.25rem',
    fontSize: '0.85rem',
    fontWeight: 600,
    color: 'white',
    background: 'linear-gradient(135deg, #059669 0%, #0891b2 100%)',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    boxShadow: '0 2px 8px rgba(5, 150, 105, 0.3)',
    transition: 'all 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
  },
  buttonHovered: {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 20px rgba(5, 150, 105, 0.45)',
  },
};

export default CookieConsent;
